import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import SectionTag from "@/components/SectionTag";
import { SITE } from "@/data/site";

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <Seo
        title="Privacy Policy | Advantage Primary Health"
        description="Privacy policy for the Advantage Primary Health website in Prescott Valley, AZ."
      />
      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-4 pb-24 pt-14 sm:px-6 md:pt-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <SectionTag number="PP" label="Your Privacy" />
            <h1 className="mt-5 font-display text-4xl font-extrabold tracking-tight text-brand-navy sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
              Last updated: July 2026
            </p>
            <div className="mt-10 space-y-8 text-base leading-relaxed text-slate-600">
              <div>
                <h2 className="font-display text-lg font-semibold text-brand-navy">
                  Information we collect
                </h2>
                <p className="mt-3">
                  This website does not collect, store, or process any personal
                  or medical information. There are no contact forms, account
                  systems, or patient portals on this site. Please never send
                  medical details through general web forms or email.
                </p>
              </div>
              <div>
                <h2 className="font-display text-lg font-semibold text-brand-navy">
                  Third-party services
                </h2>
                <p className="mt-3">
                  The “Book Online” button links to our scheduling partner,
                  athenahealth, which opens in a new browser tab. Any
                  information you provide there is governed by athenahealth's
                  own privacy policy and safeguards. This site also embeds
                  Google Maps and links to Google Reviews, which are subject to
                  Google's privacy policy.
                </p>
              </div>
              <div>
                <h2 className="font-display text-lg font-semibold text-brand-navy">
                  Your health information
                </h2>
                <p className="mt-3">
                  Medical information you share with Advantage Primary Health
                  as a patient is protected under HIPAA and is never collected
                  through this website. For questions about your health
                  information, please call our office at{" "}
                  <a
                    href={SITE.phoneHref}
                    data-testid="privacy-phone-link"
                    className="font-semibold text-brand-red hover:text-brand-redhover"
                  >
                    {SITE.phone}
                  </a>
                  .
                </p>
              </div>
              <div>
                <h2 className="font-display text-lg font-semibold text-brand-navy">
                  Contact
                </h2>
                <p className="mt-3">
                  Advantage Primary Health
                  <br />
                  {SITE.address}
                  <br />
                  {SITE.phone}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
